import { useState, useEffect } from "react"

import { useRootQuery } from "graphql/smart-queries/user"
import { maybeGetActiveJourney } from "shared/user/helpers"
import { routeBasenames } from "routes"
import { JourneyKindEnum } from "typings/types"

enum FlowVersionEnum {
  V2 = "V2",
  V3 = "V3"
}

type FlowType = {
  url: string
  version: FlowVersionEnum
}

export const FLOWS: { [key in FlowVersionEnum]: FlowType } = {
  V2: { url: routeBasenames.getStarted, version: FlowVersionEnum.V2 },
  V3: { url: routeBasenames.purchase, version: FlowVersionEnum.V3 }
}

export const useCurrentFlow = () => {
  const { data, loading } = useRootQuery()
  const [flow, setFlow] = useState<Maybe<FlowType>>(undefined)

  useEffect(() => {
    if (data?.currentOffer?.topBannerText) {
      const isPercentageOffer = data.currentOffer.topBannerText.includes("%")
      const activeJourney = maybeGetActiveJourney(data.user)

      /* some users are v2 and have a percentage offer, we should direct the to FLOWS.V2  */
      let flowType

      if (activeJourney) {
        flowType = [JourneyKindEnum.CoveECommerce, JourneyKindEnum.CoveLtdd].includes(activeJourney.kind)
          ? FLOWS.V2
          : FLOWS.V3
      } else {
        flowType = isPercentageOffer ? FLOWS.V3 : FLOWS.V2
      }

      setFlow(flowType)
    }
  }, [loading])

  return {
    userId: data?.user?.id || undefined,
    flow,
    loading
  }
}
